<div class="col ps-lg-5">
	<div class="row">
		<div *ngIf="!isFullScreen" class="col-lg-7 col-12">
			<div class="row my-3">
				<app-nav-routes [addable]="false"></app-nav-routes>
			</div>

			<div>
				<app-day-selector [etat]="stateKey"> </app-day-selector>
			</div>

			<div class="row my-3">
				<div class="d-flex justify-content-between">
					<div class="hand-cursor">
						<span class="fs-5"
							><span class="theme-main-color"
								><span class="fw-bold"
									>Tournées {{ etat | lowercase }} du : </span
								><span *ngIf="selectedDate">{{
									selectedDate.getDate() +
										' ' +
										monthsFr[selectedDate.getMonth()] +
										' ' +
										selectedDate.getFullYear()
								}}</span></span
							></span
						>
					</div>
				</div>
				<div class="row my-3">
					<div class="d-flex justify-content-between">
						<button
							class="btn"
							(click)="changeSelectedRouteIndex(null)"
							[ngClass]="{
								'theme-main-color-full-button':
									!selectedRouteIndex && selectedRouteIndex !== 0,
								'theme-main-color-button':
									selectedRouteIndex || selectedRouteIndex === 0
							}"
						>
							Afficher tout
						</button>
					</div>
				</div>
			</div>

			<div
				class="py-3 mb-3 mx-1 row bg-light text-center"
				*ngIf="listRoute.length > 0"
			>
				<div class="col-6">
					<i
						class="fs-4 theme-blue-color bi bi-hourglass-split"
						aria-hidden="true"
					></i>
					<span class="fs-5">
						Durée totale : {{ calculTotal('dur') | minutesToTime }}</span
					>
				</div>
				<div class="col-6">
					<i
						class="fs-4 theme-blue-color bi bi-signpost-2-fill"
						aria-hidden="true"
					></i>
					<span class="fs-5">
						Distance totale :
						{{ calculTotal('dist') | number: '1.1-2' }} km</span
					>
				</div>
			</div>

			<div class="row my-3">
				<div class="accordion" #accordionMission id="accordionMission">
					<div
						*ngFor="let route of listRoute; let i = index"
						class="accordion-item"
						#routeDropdownListing
						[ngClass]="{
							'd-none': route.plannedDistance === 0 || route.plannedTime === 0
						}"
					>
						<h2 class="accordion-header" id="{{ 'heading-' + i }}">
							<button
								(click)="changeSelectedRouteIndex(i)"
								class="accordion-button collapsed"
								type="button"
								[attr.data-bs-toggle]="
									selectedRouteIndex ? 'collapse' : 'collapse'
								"
								[attr.data-bs-target]="
									selectedRouteIndex ? '#collapse-' + i : '#collapse-' + i
								"
								[attr.aria-expanded]="selectedRouteIndex ? false : false"
								[attr.aria-controls]="
									selectedRouteIndex ? 'collapse-' + i : 'collapse-' + i
								"
							>
								<span class="theme-main-color"
									><span class="fw-bold">{{
										'Tournée ' + (i + 1) + ' : '
									}}</span
									><span>{{
										route.planning.employee.firstName +
											'
                                        ' +
											route.planning.employee.lastName
									}}</span>
									<span class="">
										<span class="mx-2">
											(<i
												class="bi theme-blue-color bi-hourglass-split"
												aria-hidden="true"
											></i>
											{{ route.plannedTime | minutesToTime }}
										</span>
										<span class="">
											<i
												class="bi theme-blue-color bi-signpost-2-fill"
												aria-hidden="true"
											></i>
											{{ route.plannedDistance / 1000 | number: '1.1-2' }} km)
										</span>
									</span>
								</span>
							</button>
						</h2>
						<div
							id="{{ 'collapse-' + i }}"
							class="accordion-collapse collapse"
							[attr.aria-labelledby]="'heading-' + i"
							[attr.data-bs-parent]="'#accordionMission'"
						>
							<div class="accordion-body">
								<div *ngIf="!isSESSAD" class="row mb-3">
									<div
										class="d-lg-flex justify-content-lg-end justify-content-center"
									>
										<button
											*ngIf="
												stateEnum[listRoute[i].state] === stateEnum.UNDER_REVIEW
												&& !isSolutionValidated
											"
											class="btn my-2 theme-main-color-button mx-2"
											(click)="reorderRoute(i)"
										>
											Réordonner la tournée
										</button>
										<button
											*ngIf="
												stateEnum[listRoute[i].state] === stateEnum.PENDING
												&& isSolutionValidated
											"
											class="btn my-2 theme-red-button mx-2"
											(click)="invalidateRoute(i)"
											[disabled]="isBtnValidateRouteClicked"
										>
											Invalider la tournée
										</button>
										<button
											*ngIf="
												stateEnum[listRoute[i].state] === stateEnum.UNDER_REVIEW
												&& !isSolutionValidated
											"
											class="btn my-2 theme-main-color-button mx-2"
											(click)="
												openModalReaffectationRoute(
													templateReafectationRoute,
													i
												)
											"
										>
											Réaffecter
										</button>
										<button
											*ngIf="
												stateEnum[listRoute[i].state] === stateEnum.UNDER_REVIEW
												&& isSolutionValidated
											"
											class="btn my-2 theme-green-button mx-2"
											(click)="validateRoute(i)"
											[disabled]="isBtnValidateRouteClicked"
										>
											Valider la tournée
										</button>
									</div>
								</div>
								<hr />
								<div *ngIf="!isMobile" class="row">
									<div class="col-4">
										<span class="theme-main-color fw-bold ms-2">{{
											labelBeneficiaire | titlecase
										}}</span>
									</div>
									<div *ngIf="isSESSAD" class="col-4">
										<span class="theme-main-color fw-bold">{{
											'Lieu' | titlecase
										}}</span>
									</div>
									<div class="col-2">
										<span class="theme-main-color fw-bold">Début</span>
									</div>
									<div class="col-2">
										<span class="theme-main-color fw-bold">Durée</span>
									</div>
									<div class="col-2">
										<span class="theme-main-color fw-bold">État</span>
									</div>
									<div *ngIf="!isSESSAD" class="col-2"></div>
								</div>
								<div class="row">
									<div
										*ngFor="let mission of listRoute[i].missions; let j = index"
										class="row my-2 hand-cursor mx-0"
										id="{{ 'r' + i + 'm' + j }}"
										(click)="triggerPopupOnMap(mission.id)"
									>
										<div
											class="col-lg-4 col-12"
											[ngClass]="{ 'mt-2': !isSESSAD }"
										>
											<span class="theme-main-color">
												<span *ngIf="isMobile" class="fw-bold"
													>Bénéficiaire :
												</span>
												{{
													mission?.missionRequest?.beneficiaire?.firstName +
														' ' +
														mission?.missionRequest?.beneficiaire?.lastName
												}}
											</span>
										</div>
										<div *ngIf="isSESSAD" class="col-lg-4 col-12">
											<span class="theme-main-color">
												{{
													mission?.missionRequest?.missionPlace?.nameDisplay
														| titlecase
												}}
											</span>
										</div>
										<div
											class="col-lg-2 col-12"
											[ngClass]="{ 'mt-2': !isSESSAD }"
										>
											<span class="theme-main-color">
												<span *ngIf="isMobile" class="fw-bold">Début : </span>
												{{ mission?.realStart | minutesToTime }}</span
											>
										</div>
										<div
											class="col-lg-2 col-12"
											[ngClass]="{ 'mt-2': !isSESSAD }"
										>
											<span class="theme-main-color">
												<span *ngIf="isMobile" class="fw-bold">Durée :</span>
												{{
													mission?.realEnd - mission?.realStart > 0
														? (mission?.realEnd - mission?.realStart | number)
														: 0
												}}
												min</span
											>
										</div>
										<div
											class="col-lg-2 col-12"
											[ngClass]="{ 'mt-2': !isSESSAD }"
										>
											<span class="theme-main-color">
												<span *ngIf="isMobile" class="fw-bold">État : </span>
												{{ mission?.state | convertStateToString }}</span
											>
										</div>
										<div *ngIf="!isSESSAD" class="col-2">
											<div class="d-flex justify-content-end">
												<div
													*ngIf="
														stateEnum[listRoute[i].state] ===
														stateEnum.UNDER_REVIEW
													"
													style="transform: scale(-1, 1)"
													class="ms-3"
												>
													<a
														(click)="
															openModalReaffectationMission(
																templateReafectationMission,
																i,
																j
															)
														"
														><i
															class="bi bi-reply-fill theme-main-color fs-3"
															aria-hidden="true"
														></i
													></a>
												</div>
												<div
													*ngIf="
														stateEnum[listRoute[i].state] ===
														stateEnum.UNDER_REVIEW
													"
													class="ms-3"
												>
													<a
														(click)="
															openModalSuppression(templateSuppression, j, i)
														"
														><i
															class="bi bi-trash theme-red-color fs-3"
															aria-hidden="true"
														></i
													></a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--MAP-->
		<div class="col pt-5">
			<div
				class="vh-85 z-index-0 sticky"
				id="map"
				leaflet
				[leafletOptions]="options"
				(leafletMapReady)="onMapReady($event)"
				[leafletLayersControl]="layersControl"
			>
				<div
					style="z-index: 99999; position: relative"
					class="position-absolute"
				>
					<div class="d-flex flex-column m-2">
						<span
							*ngIf="!isFullScreen"
							class="hand-cursor my-2 px-2 text-center bg-white rounded-pill"
							(click)="onClickFullScreen()"
							><i
								class="bi bi-fullscreen fs-5 theme-main-color"
								aria-hidden="true"
							></i
						></span>
						<span
							*ngIf="isFullScreen"
							class="hand-cursor my-2 px-2 text-center bg-white rounded-pill"
							(click)="onClickFullScreen()"
							><i
								class="bi bi-fullscreen-exit fs-5 theme-main-color"
								aria-hidden="true"
							></i
						></span>

						<div
							class="d-flex p-0 flex-column my-2 text-center bg-white rounded-pill"
						>
							<span
								class="hand-cursor mb-0 text-center border-bottom border-dark"
								(click)="onClickZoomIn()"
								><i
									class="bi bi-plus fs-5 theme-main-color"
									aria-hidden="true"
								></i
							></span>
							<span
								class="hand-cursor mt-0 text-center"
								(click)="onClickZoomOut()"
								><i class="bi bi-dash fs-5" aria-hidden="true"></i
							></span>
						</div>

						<span
							class="hand-cursor my-2 px-2 text-center bg-white rounded-pill"
							(click)="onClickCenter()"
							><i
								class="bi bi-geo-alt-fill fs-5 theme-main-color"
								aria-hidden="true"
							></i
						></span>

						<span
							*ngIf="!isCrowflightSelected"
							class="hand-cursor my-2 px-2 text-center bg-white rounded-pill"
							(click)="onClickDrawingMode()"
							><i
								class="bi bi-map-fill fs-5 theme-main-color"
								aria-hidden="true"
							></i
						></span>
						<span
							*ngIf="isCrowflightSelected"
							class="hand-cursor my-2 px-2 text-center bg-white rounded-pill"
							(click)="onClickDrawingMode()"
							><i
								class="bi bi-rulers fs-5 theme-main-color"
								aria-hidden="true"
							></i
						></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #templateReafectationRoute>
	<div class="modal-header">
		<h4 class="modal-title pull-left">Réaffectation tournée</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="mb-3">
				<label for="selectReafect" class="form-label"
					>A qui réaffecter la tournée ?</label
				>
				<select
					class="form-select"
					[(ngModel)]="idEmployeeReafectation"
					aria-label="selectReafect"
					id="selectReafect"
				>
					<option
						*ngFor="let emp of listEmployeeAvailableRoute"
						[value]="emp.id"
					>
						{{ emp.firstName + ' ' + emp.lastName }}
					</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="d-flex justify-content-end">
				<button
					class="btn theme-green-button"
					(click)="reaffecterRoute()"
					[disabled]="isBtnReaffecterClicked"
				>
					Réaffecter
				</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #templateReafectationMission>
	<div class="modal-header">
		<h4 class="modal-title pull-left">
			Déplacement de {{ labelIntervention }}
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="mb-3">
				<label for="selectReafect" class="form-label"
					>Vers qui effectuer le déplacement ?</label
				>
				<select
					class="form-select"
					[(ngModel)]="idEmployeeReafectation"
					aria-label="selectReafect"
					id="selectReafect"
				>
					<option
						*ngFor="let emp of listEmployeeAvailableMission"
						[value]="emp.id"
					>
						{{ emp.firstName + ' ' + emp.lastName }}
					</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="d-flex justify-content-end">
				<button
					class="btn theme-green-button"
					(click)="reaffecterMission()"
					[disabled]="isBtnDeplacerClicked"
				>
					Déplacer
				</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #templateSuppression>
	<div class="modal-header">
		<h4 class="modal-title pull-left">
			Voulez-vous vraiment supprimer la prestation ?
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="d-flex justify-content-end">
				<button
					class="btn theme-main-color-button mx-2"
					(click)="modalRef?.hide()"
				>
					Non
				</button>
				<button
					class="btn theme-red-button"
					(click)="deleteMissionFromRoute()"
					[disabled]="isBtnSupprimerClicked"
				>
					Oui
				</button>
			</div>
		</div>
	</div>
</ng-template>
